module.exports = __webpack_public_path__ + "static/img/nav2.e925e44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav2.jpg
// module id = Xd3L
// module chunks = 62